<template>
  <div class="notice">
    <div class="notice_box">
      <div class="notice_img">
        <el-carousel height="338px" :autoplay="true">
          <!-- <el-carousel-item
            v-for="(carouselItem, index) in carouselList"
            :key="index"
          >
            <p class="carousel_title">{{ carouselItem.title }}</p>
            <img
              :src="'http://cce.scu.edu.cn/' + carouselItem.image"
              alt="新闻公告"
            />
          </el-carousel-item> -->
          <el-carousel-item>
            <p class="carousel_title" @click="goCarouselDetail" style="cursor:pointer;">{{bannerTitle}}</p>
            <img
              src="./image/leftNew02.png"
              alt="招生简章"
              @click="goCarouselDetail"
            />
          </el-carousel-item>
        </el-carousel>
        <!-- <img src="./image/leftNew.png" alt="新闻" /> -->
        <!-- <p>继续教育学院召开专题学习会集体收看《榜样6》</p> -->
      </div>
      <div class="content_box">
        <el-tabs ref="tabsRrf">
          <el-tab-pane label="通知公告">
            <ul>
              <li
                v-for="(noticeItem, index) in noticeList"
                :key="noticeItem.id"
              >
                <a :href="noticeItem.url" target="_blank">
                  <span v-if="noticeItem.stick == 1">
                    <span style="color: #ba2a17" :title="noticeItem.title"
                      >【置顶】</span
                    >
                    {{ noticeItem.curTitle }}
                  </span>
                  <span v-else :title="noticeItem.title">{{
                    noticeItem.curTitle
                  }}</span>
                </a>
                <span class="time">{{ noticeItem.public_date }}</span>
                <hr />
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="学院新闻">
            <ul>
              <li v-for="(newsItem, index) in newsList" :key="newsItem.id">
                <a :href="newsItem.url" target="_blank">
                  <span v-if="newsItem.stick == 1">
                    <span style="color: #ba2a17" :title="newsItem.title"
                      >【置顶】</span
                    >
                    {{ newsItem.curTitle }}
                  </span>
                  <span v-else :title="newsItem.title">{{
                    newsItem.curTitle
                  }}</span>
                </a>
                <span class="time">{{ newsItem.public_date }}</span>
                <hr />
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
        <span class="more"><a :href="moreUrl" target="_blank">更多>></a></span>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList,getBannerTitle } from "@/api/api2";
export default {
  data() {
    return {
      // activeName: "first",
      noticeParams: {
        type: 112,
        pageSize: 6,
        pageNum: 1,
        searchWord: "",
      },
      newsParams: {
        type: 8,
        pageSize: 6,
        pageNum: 1,
        searchWord: "",
      },
      // carouselParams: {
      //   type: 554,
      //   pageSize: 4,
      //   pageNum: 1,
      //   searchWord: "",
      // },
      noticeList: [],
      newsList: [],
      //默认选择的就是通知公告的更多URL
      moreUrl: "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=112",
      carouselList: [],
      isFirstEnter:true,
      bannerTitle:""
    };
  },
  mounted() {
    getBannerTitle({id:3985}).then(res=>{
      this.bannerTitle=res.result.title;
    }),
    //获取通知列表数据
    getNewsList(this.noticeParams).then((res) => {
      let noticeArrList = new Array();
      res.result.forEach((item) => {
        item.url =
          item.url ||
          "http://cce.scu.edu.cn/mana/view/home/news.do?id=" + item.id;
        try {
          //置顶
          if (item.stick == 1) {
            noticeArrList.unshift(item);
          }
          //非置顶
          if (item.stick == 0) {
            noticeArrList.push(item);
          }
        } catch (error) {
          throw error;
        }
      });
      this.noticeList = res.result;
      this.noticeList = this.noticeList.map((v) => {
        if (v.title) {
          v["curTitle"] =
            v.title.length > 30 ? v.title.substr(0, 30) + "..." : v.title;
        }
        return v;
      });
    });
    //获取学院新闻
    getNewsList(this.newsParams).then((res) => {
      let newsArrList = new Array();
      res.result.forEach((item) => {
        item.url =
          item.url ||
          "http://cce.scu.edu.cn/mana/view/home/news.do?id=" + item.id;
        try {
          //置顶
          if (item.stick == 1) {
            newsArrList.unshift(item);
          }
          //非置顶
          if (item.stick == 0) {
            newsArrList.push(item);
          }
        } catch (error) {
          throw error;
        }
      });
      this.newsList = newsArrList;
      this.newsList = this.newsList.map((v) => {
        if (v.title) {
          v["curTitle"] =
            v.title.length > 30 ? v.title.substr(0, 30) + "..." : v.title;
        }
        return v;
      });
    });
    //获取轮播图数据
    // getNewsList(this.carouselParams).then((res) => {
    //   res.result.forEach((item) => {
    //     item.url =
    //       item.url ||
    //       "http://cce.scu.edu.cn/mana/view/home/news.do?id=" + item.id;
    //   });
    //   this.carouselList = res.result;
    // });

    // 鼠标移动到el-tabs组件上时触发切换效果
    this.$nextTick(() => {
      this.$refs.tabsRrf.$refs.nav.$nextTick(() => {
        // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
        let target = document.getElementsByClassName("el-tabs__item");
        let that = this;
        if(this.isFirstEnter){
            that.$refs.tabsRrf.handleTabClick(1, String(0));
            this.isFirstEnter=false;
        }
        for (let i = 0; i < target.length; i++) {
          target[i].addEventListener("mouseover", () => {
            that.$refs.tabsRrf.handleTabClick(1, String(i));
            // console.log(i);
            if (i == 0) {
              this.moreUrl =
                "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=112";
            }
            if (i == 1) {
              this.moreUrl =
                "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=8";
            }
          });
        }
      });
    });
  },
  methods: {
    // handleClick(tab, event) {
    //   if (tab.label == "通知公告") {
    //     this.moreUrl =
    //       "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=114";
    //   }
    //   if (tab.label == "新闻动态") {
    //     this.moreUrl =
    //       "http://cce.scu.edu.cn/mana/view/home/newsList.do?type=8";
    //   }
    // },
    // goCarouselDetails(item) {
    //   window.open(item.url);
    // },
    goCarouselDetail(){
      window.open("http://cce.scu.edu.cn/mana/view/home/news.do?id=3985");
    }
  },
};
</script>

<style scoped lang="scss">
.notice {
  width: 100%;
  height: 338px;
  padding: 65px 0 65px 0;
  background-color: #fff;
  .notice_box {
    width: 1200px;
    height: 100%;
    background-color: #fff;
    margin: 0 auto;
    & > div {
      float: left;
    }
    .notice_img {
      position: relative;
      width: 512px;
      height: 100%;
      // overflow: hidden;
      // img {
      //   width: 100%;
      //   height: 100%;
      //   transition: all 1s;
      //   &:hover {
      //     transform: scale(1.1);
      //   }
      // }
      //轮播图样式start
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
      }
      //轮播图样式end
      .el-carousel {
        position: relative;
        img {
          cursor: pointer;
          width: 100%;
          height: 100%;
        }
        .el-carousel-item {
          width: 100%;
          height: 100%;
        }
      }
    }
    .content_box {
      position: relative;
      width: 628px;
      height: 100%;
      padding-left: 60px;
      .el-tab-pane {
        font-size: 12px;
      }
      ::v-deep .el-tabs__item.is-active {
        color: #ba2a17 !important;
      }
      ::v-deep .el-tabs__item {
        line-height: 20px;
        font-size: 18px !important;
        font-weight: 600 !important;
        color: #333 !important;
      }
      ::v-deep .el-tabs__active-bar {
        opacity: 0 !important;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px !important;
      }
      .more {
        position: absolute;
        top: 8px;
        right: 0;
        font-size: 12px;
        color: #999;
        font-weight: 600;
        cursor: pointer;
        a:link {
          color: #999;
        }
        a:visited {
          color: #999;
        }
        a:hover {
          color: #ba2a17;
        }
        a:active {
          color: #999;
        }
      }
      ul li {
        position: relative;
        font-size: 14px;
        color: #333;
        line-height: 34px;
        .time {
          position: absolute;
          right: 0;
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
}
p.carousel_title {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  color: #fff;
  background-color: rgba(31, 31, 31, 0.751);
  margin: 0;
  padding-left: 10px;
}
::v-deep .el-carousel__indicators--horizontal {
  bottom: 40px !important;
}
</style>
